import CustomFieldManager from "../../Manager/CustomFieldManager"
import TemplateSettingsManager from "../../Manager/TemplateSettingsManager"
import { convertDateFromERPFormatToDocFormat, getCapitalized, getConvertedDate } from "../../Utilities/Utility"
import Address from "../Address"
import AddressParser, { AddressType, OwnerType } from "../AddressParser"
import DataParser from "../DataParser"
import LineItemsParser from "../LineItemsParser"
import NewDataParser from "../NewDataParser"
import TenantParser from "../TenantParser"

export default class JournalEntryParser {
    static parseData(dataFromAPI, templateDataToReturn) {

        templateDataToReturn.customFields = dataFromAPI.journalEntry.customField
        CustomFieldManager.setCustomFields(dataFromAPI.journalEntry.customField)
        templateDataToReturn = DataParser.assignCustomFieldValue(templateDataToReturn)

         //company name
        var name = ''
        if (dataFromAPI.tenantInfo !== undefined && dataFromAPI.tenantInfo !== null) {
            if (dataFromAPI.tenantInfo.name !== undefined && dataFromAPI.tenantInfo.name !== null) {
                name = getCapitalized(dataFromAPI.tenantInfo.name)
            }
        }
        templateDataToReturn.companyName = name
        templateDataToReturn.tenantInfo = dataFromAPI.tenantInfo;

        //company address
        var fromAddressObj = undefined
        if (dataFromAPI.tenantInfo !== undefined && dataFromAPI.tenantInfo !== null) {
            if (dataFromAPI.tenantInfo.address !== undefined && dataFromAPI.tenantInfo.address !== null) {
                fromAddressObj = new Address(undefined, dataFromAPI.tenantInfo.address, dataFromAPI.pan, dataFromAPI.gstin, dataFromAPI.tenantInfo.contactNumber, undefined, OwnerType.tenant)
            }
        }
        templateDataToReturn.fromObj = fromAddressObj
        templateDataToReturn = AddressParser.assignAddressObjToStringForNonArabic(undefined, AddressType.from, templateDataToReturn)

        // billing to address
        templateDataToReturn.clientBillToAddress = ''

        // shipping to address
        templateDataToReturn.clientShipToAddress = ''

        //currency
        templateDataToReturn.currency = dataFromAPI.currencySymbol
        templateDataToReturn.currencyName = dataFromAPI.currency

        //ref number
        var journalEntryNumber = ''
        var linkDocumentNumber = ''
        var linkDocumentType = ''
        if (dataFromAPI.journalEntry.jeCode !== undefined && dataFromAPI.journalEntry.jeCode !== null) {
            journalEntryNumber = dataFromAPI.journalEntry.jeCode
        }
        if (dataFromAPI.parentDocument !== undefined && dataFromAPI.parentDocument !== null) {
            linkDocumentNumber = NewDataParser.getDefaultValue(dataFromAPI.parentDocument.documentCode)
            linkDocumentType = NewDataParser.getDefaultValue(dataFromAPI.parentDocument.documentType)
        }

        templateDataToReturn.refNumber = journalEntryNumber
        templateDataToReturn.linkDocumentNumber = linkDocumentNumber
        templateDataToReturn.linkDocumentType = linkDocumentType
        templateDataToReturn.showLinkDocumentNumber = TemplateSettingsManager.defaultTemplateSettings.documentInfo.documentDetails.linkDocumentNumber.isVisible

        //start date
        var journalEntryDate = ''
        if (dataFromAPI.journalEntry.jeDate !== undefined && dataFromAPI.journalEntry.jeDate !== null) {
            journalEntryDate = dataFromAPI.journalEntry.jeDate
        }
        templateDataToReturn.date = getConvertedDate(convertDateFromERPFormatToDocFormat(journalEntryDate), templateDataToReturn.dateFormat)

        //due date
        templateDataToReturn.dueDate = ''
        templateDataToReturn.showDueDate = false

        //line item
        templateDataToReturn.lineItems = LineItemsParser.getJournalEntryItem(dataFromAPI, templateDataToReturn.dateFormat)

        //notes
        if (dataFromAPI.journalEntry !== undefined && dataFromAPI.journalEntry !== null) {
            if (dataFromAPI.journalEntry.memo !== undefined && dataFromAPI.journalEntry.memo !== null) {
                templateDataToReturn.notes = dataFromAPI.journalEntry.memo
            }
        }

        //location
        templateDataToReturn = TenantParser.parseLocationDetail(dataFromAPI, templateDataToReturn)

        return templateDataToReturn
    }
}
